import api from './api';

/**
 * Blog Ad Service (Admin Panel)
 * مدیریت تبلیغات بخش بلاگ
 */

export type BlogAdSlot =
  | 'blog_top_strip'
  | 'blog_home_top'
  | 'blog_home_double_right'
  | 'blog_home_double_left'
  | 'blog_home_bottom_right'
  | 'blog_home_bottom_left'
  | 'blog_list_sidebar_r1'
  | 'blog_list_sidebar_r2'
  | 'blog_list_sidebar_r3'
  | 'blog_category_sidebar_right'
  | 'blog_category_sidebar_left'
  | 'blog_article_top'
  | 'blog_article_sidebar'
  | 'blog_article_sidebar_2'
  | 'blog_article_sidebar_wide_1'
  | 'blog_list_inline';

export interface BlogAdPayload {
  name: string;
  slot: BlogAdSlot;
  image: string;
  mobileImage?: string;
  imageAlt?: string;
  linkUrl?: string;
  openInNewTab?: boolean;
  startDate?: string;
  endDate?: string;
  order?: number;
  isActive?: boolean;
}

export interface BlogAdListParams {
  page?: number;
  limit?: number;
  search?: string;
  slot?: string;
  isActive?: boolean | string;
}

export const listBlogAds = async (params: BlogAdListParams = {}) => {
  const response = await api.get('/admin/blog-ads', { params }) as any;
  return response;
};

export const getBlogAdById = async (id: string) => {
  const response = await api.get(`/admin/blog-ads/${id}`) as any;
  return response;
};

export const createBlogAd = async (data: BlogAdPayload) => {
  const response = await api.post('/admin/blog-ads', data) as any;
  return response;
};

export const updateBlogAd = async (id: string, data: Partial<BlogAdPayload>) => {
  const response = await api.put(`/admin/blog-ads/${id}`, data) as any;
  return response;
};

export const deleteBlogAd = async (id: string) => {
  const response = await api.delete(`/admin/blog-ads/${id}`) as any;
  return response;
};

export const toggleBlogAdActive = async (id: string, isActive: boolean) => {
  const response = await api.patch(`/admin/blog-ads/${id}/toggle-active`, { isActive }) as any;
  return response;
};
